import Vue from 'vue';
import BzbsApi from '@/core/Http/BzbsApi.js';
import CampaignModel from '../model/CampaignModel.js';
import { map } from 'rxjs/operators';

/**
 * @method apiGetCampaign
 * @method apiGetCampaignDetail
 */
export default {
    /**
     * @param {String} strBzbsToken
     * @param {Object} objListConfig (Require) CampaignListConfigModel - /core/Campaign/model/CampaignConfigModel.js
     * @param {Object} objListFilterConfig (Optional) CampaignListFilterConfigModel - /core/Campaign/model/CampaignConfigModel.js
     */
    apiGetCampaign: function (strBzbsToken, objListConfig, objListFilterConfig) {
        var params = objListConfig.getParams();
        if (objListFilterConfig != null) {
            var filter = objListFilterConfig.getParams();
            params = {...params , ...filter};
        }

        var strUrl = Vue.bzbsConfig.bzbsUrl+ "/campaign";
        return BzbsApi.connectBzbsGet(strUrl, strBzbsToken, params).pipe(map((res) => {
            var arrCampaign = [];
            for (var i of res.data) {
                var objCampaign = new CampaignModel(i);
                arrCampaign.push(objCampaign);
            }

            return arrCampaign;
        }));
    },

    /**
     * @param {String} strBzbsToken (Require)
     * @param {Object} objDetailConfig (Require) CampaignConfigModel - /core/Campaign/model/CampaignConfigModel.js
     */
    apiGetCampaignDetail: function (strBzbsToken, objDetailConfig) {
        var params = objDetailConfig.getParams();
        var url = Vue.bzbsConfig.bzbsUrl + "/campaign/" + objDetailConfig.strId;

        return BzbsApi.connectBzbsGet(url, strBzbsToken, params).pipe(map((res) => {
            var campaign = new CampaignModel(res.data);
            return campaign;
        }));
    }
}
